import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SEO from './components/SEO';
import Home from './pages/Home';
import About from './pages/About';
import SriLanka from './pages/SriLanka';
import TourPackages from './pages/TourPackages';
import ThingsToDo from './pages/ThingsToDo';
import Bookings from './pages/Bookings';
import ContactUs from './pages/ContactUs';
import AyurvedaPage from './pages/AyurvedaPage';
import DivingPage from './pages/DivingPage';
import ElephantRidePage from './pages/ElephantRidePage';
import FishingPage from './pages/FishingPage';
import BallooningPage from './pages/BallooningPage';
import JeepSafariPage from './pages/JeepSafariPage';
import WhiteWaterRaftingPage from './pages/WhiteWaterRaftingPage';
import RiverSafariPage from './pages/RiverSafariPage';
import SnorkelingPage from './pages/SnorkelingPage';
import TeaTastingPage from './pages/TeaTastingPage';
import TempleVisitPage from './pages/TempleVisitPage';
import WildlifeSafariPage from './pages/WildlifeSafariPage';
import WhatsApp from './components/WhatsApp';
import Facebook from './components/Facebook';
import Instagram from './components/Instagram';
import Gallery from './pages/Gallery';
import Events from './pages/Events';

const App = () => {
  return (
    <Router>
      <Navbar />
      <main className="min-h-screen">
        <Routes>
          {/* Main Routes */}
          <Route
            path="/"
            element={
              <>
                <SEO
                  title="Pick Lanka Tours - Discover Sri Lanka"
                  description="Join Pick Lanka Tours to explore Sri Lanka’s stunning landscapes, wildlife safaris, and breathtaking adventures. Let’s make your journey unforgettable!"
                  keywords="Pick Lanka Tours, Sri Lanka Tours, Travel Sri Lanka, Tour Packages, Adventure Tours, Wildlife Safari, Beach Holidays, Beruwala Tours"
                  url="https://picklanka.com"
                />
                <Home />
              </>
            }
          />
          <Route
            path="/about-us"
            element={
              <>
                <SEO
                  title="About Us - Pick Lanka Tours"
                  description="Learn about Pick Lanka Tours, your trusted Sri Lankan travel partner offering personalized and memorable tour experiences across the island."
                  keywords="Pick Lanka Tours, About Pick Lanka, Sri Lanka Travel Company, Beruwala Tours, Sri Lanka Tour Operator"
                  url="https://picklanka.com/about-us"
                />
                <About />
              </>
            }
          />
          <Route
            path="/srilanka"
            element={
              <>
                <SEO
                  title="Explore Sri Lanka - Pick Lanka Tours"
                  description="Discover the wonders of Sri Lanka with Pick Lanka Tours — from golden beaches to wildlife safaris and scenic hill country."
                  keywords="Explore Sri Lanka, Pick Lanka Tours, Sri Lanka Travel, Nature Tours, Wildlife Safari, Beach Holidays"
                  url="https://picklanka.com/srilanka"
                />
                <SriLanka />
              </>
            }
          />
          <Route
            path="/tour"
            element={
              <>
                <SEO
                  title="Tour Packages - Pick Lanka Tours"
                  description="Choose from our exclusive Pick Lanka Tours packages featuring wildlife adventures, beach getaways, and nature experiences."
                  keywords="Sri Lanka Tour Packages, Pick Lanka Tours, Adventure Tours, Wildlife Tours, Holiday Packages"
                  url="https://picklanka.com/tour"
                />
                <TourPackages />
              </>
            }
          />
          <Route
            path="/gallery"
            element={
              <>
                <SEO
                  title="Gallery - Pick Lanka Tours"
                  description="Browse through moments captured during Pick Lanka Tours’ amazing journeys across Sri Lanka."
                  keywords="Sri Lanka Travel Photos, Pick Lanka Tours Gallery, Sri Lanka Adventures, Travel Memories"
                  url="https://picklanka.com/gallery"
                />
                <Gallery />
              </>
            }
          />
          <Route
            path="/events"
            element={
              <>
                <SEO
                  title="Events - Pick Lanka Tours"
                  description="Celebrate Sri Lanka’s colorful festivals and special events with Pick Lanka Tours — where culture meets adventure."
                  keywords="Sri Lanka Events, Pick Lanka Tours, Cultural Festivals, Local Experiences"
                  url="https://picklanka.com/events"
                />
                <Events />
              </>
            }
          />
          <Route
            path="/things"
            element={
              <>
                <SEO
                  title="Things To Do - Pick Lanka Tours"
                  description="Find exciting things to do with Pick Lanka Tours — from safaris and diving to hot air ballooning and tea tasting."
                  keywords="Things To Do Sri Lanka, Pick Lanka Tours, Adventure Activities, Safari Tours, Sri Lanka Experiences"
                  url="https://picklanka.com/things"
                />
                <ThingsToDo />
              </>
            }
          />
          <Route
            path="/bookings"
            element={
              <>
                <SEO
                  title="Bookings - Pick Lanka Tours"
                  description="Book your dream Sri Lankan tour with Pick Lanka. Easy reservations and custom travel experiences await you!"
                  keywords="Book Sri Lanka Tours, Pick Lanka Bookings, Travel Reservations, Holiday Packages"
                  url="https://picklanka.com/bookings"
                />
                <Bookings />
              </>
            }
          />
          <Route
            path="/contact-us"
            element={
              <>
                <SEO
                  title="Contact Us - Pick Lanka Tours"
                  description="Get in touch with Pick Lanka Tours for travel inquiries and bookings. Call us or message via WhatsApp for quick assistance."
                  keywords="Contact Pick Lanka, Sri Lanka Tour Contact, Beruwala Tours, Travel Inquiries"
                  url="https://picklanka.com/contact-us"
                />
                <ContactUs />
              </>
            }
          />

          {/* Things To Do Individual Pages */}
          <Route
            path="/ayurveda"
            element={
              <>
                <SEO
                  title="Ayurveda Experiences - Pick Lanka Tours"
                  description="Rejuvenate your body and mind with traditional Ayurveda treatments arranged by Pick Lanka Tours in Sri Lanka."
                  keywords="Ayurveda Sri Lanka, Pick Lanka Wellness Tours, Traditional Healing, Spa Packages"
                  url="https://picklanka.com/ayurveda"
                />
                <AyurvedaPage />
              </>
            }
          />
          <Route
            path="/diving"
            element={
              <>
                <SEO
                  title="Diving in Sri Lanka - Pick Lanka Tours"
                  description="Explore the vibrant marine life of Sri Lanka with diving adventures guided by Pick Lanka Tours."
                  keywords="Diving Sri Lanka, Pick Lanka Diving, Underwater Adventures, Coral Reefs"
                  url="https://picklanka.com/diving"
                />
                <DivingPage />
              </>
            }
          />
          <Route
            path="/elephant-ride"
            element={
              <>
                <SEO
                  title="Elephant Experiences - Pick Lanka Tours"
                  description="Get close to Sri Lanka’s gentle giants with Pick Lanka’s ethical elephant experiences and safaris."
                  keywords="Elephant Safari Sri Lanka, Pick Lanka Tours, Wildlife Experiences"
                  url="https://picklanka.com/elephant-ride"
                />
                <ElephantRidePage />
              </>
            }
          />
          <Route
            path="/fishing"
            element={
              <>
                <SEO
                  title="Fishing Trips - Pick Lanka Tours"
                  description="Enjoy exciting fishing excursions along Sri Lanka’s coastal waters with Pick Lanka Tours."
                  keywords="Fishing Sri Lanka, Pick Lanka Tours, Deep Sea Fishing, Adventure Tours"
                  url="https://picklanka.com/fishing"
                />
                <FishingPage />
              </>
            }
          />
          <Route
            path="/ballooning"
            element={
              <>
                <SEO
                  title="Hot Air Ballooning - Pick Lanka Tours"
                  description="Soar high over Sri Lanka’s breathtaking scenery with Pick Lanka’s hot air balloon rides."
                  keywords="Hot Air Ballooning Sri Lanka, Pick Lanka Adventure, Scenic Flights"
                  url="https://picklanka.com/ballooning"
                />
                <BallooningPage />
              </>
            }
          />
          <Route
            path="/jeep-safari"
            element={
              <>
                <SEO
                  title="Jeep Safari - Pick Lanka Tours"
                  description="Join Pick Lanka for thrilling jeep safaris through Sri Lanka’s wildlife-rich national parks."
                  keywords="Jeep Safari Sri Lanka, Pick Lanka Wildlife, National Park Safari"
                  url="https://picklanka.com/jeep-safari"
                />
                <JeepSafariPage />
              </>
            }
          />
          <Route
            path="/white-water-rafting"
            element={
              <>
                <SEO
                  title="White Water Rafting - Pick Lanka Tours"
                  description="Experience adrenaline-pumping white water rafting in Kitulgala with Pick Lanka Tours."
                  keywords="White Water Rafting Sri Lanka, Pick Lanka Adventures, Kitulgala Rafting"
                  url="https://picklanka.com/white-water-rafting"
                />
                <WhiteWaterRaftingPage />
              </>
            }
          />
          <Route
            path="/river-safari"
            element={
              <>
                <SEO
                  title="River Safari - Pick Lanka Tours"
                  description="Relax and enjoy Sri Lanka’s beautiful river ecosystems on a scenic safari with Pick Lanka Tours."
                  keywords="River Safari Sri Lanka, Pick Lanka Nature Tours, Boat Rides"
                  url="https://picklanka.com/river-safari"
                />
                <RiverSafariPage />
              </>
            }
          />
          <Route
            path="/snorkeling"
            element={
              <>
                <SEO
                  title="Snorkeling Adventures - Pick Lanka Tours"
                  description="Discover Sri Lanka’s colorful coral reefs and tropical fish on a snorkeling trip with Pick Lanka Tours."
                  keywords="Snorkeling Sri Lanka, Pick Lanka Marine Tours, Beach Activities"
                  url="https://picklanka.com/snorkeling"
                />
                <SnorkelingPage />
              </>
            }
          />
          <Route
            path="/tea-tasting"
            element={
              <>
                <SEO
                  title="Tea Tasting - Pick Lanka Tours"
                  description="Savor the rich aroma of Ceylon tea on an exclusive tea tasting journey with Pick Lanka Tours."
                  keywords="Tea Tasting Sri Lanka, Pick Lanka Tours, Ceylon Tea, Hill Country Tours"
                  url="https://picklanka.com/tea-tasting"
                />
                <TeaTastingPage />
              </>
            }
          />
          <Route
            path="/temple-visit"
            element={
              <>
                <SEO
                  title="Temple Visits - Pick Lanka Tours"
                  description="Discover Sri Lanka’s sacred temples and ancient stories through Pick Lanka’s guided tours."
                  keywords="Temple Visit Sri Lanka, Pick Lanka Tours, Cultural Experiences"
                  url="https://picklanka.com/temple-visit"
                />
                <TempleVisitPage />
              </>
            }
          />
          <Route
            path="/wildlife-safari"
            element={
              <>
                <SEO
                  title="Wildlife Safari - Pick Lanka Tours"
                  description="Embark on thrilling wildlife safaris across Sri Lanka’s national parks with Pick Lanka Tours."
                  keywords="Wildlife Safari Sri Lanka, Pick Lanka Tours, National Park Tours, Elephant Safari"
                  url="https://picklanka.com/wildlife-safari"
                />
                <WildlifeSafariPage />
              </>
            }
          />

          {/* AU Routes (keep existing routes unchanged) */}
          <Route
            path="/au"
            element={
              <>
                <SEO
                  title="Pick Lanka Tours - Discover Sri Lanka"
                  description="Join Pick Lanka Tours to explore Sri Lanka’s stunning landscapes, wildlife safaris, and breathtaking adventures. Let’s make your journey unforgettable!"
                  keywords="Pick Lanka Tours, Sri Lanka Tours, Travel Sri Lanka, Tour Packages, Adventure Tours, Wildlife Safari, Beach Holidays, Beruwala Tours"
                  url="https://picklanka.com/au"
                />
                <Home />
              </>
            }
          />
          <Route
            path="/au/home"
            element={
              <>
                <SEO
                  title="Pick Lanka Tours - Discover Sri Lanka"
                  description="Join Pick Lanka Tours to explore Sri Lanka’s stunning landscapes, wildlife safaris, and breathtaking adventures. Let’s make your journey unforgettable!"
                  keywords="Pick Lanka Tours, Sri Lanka Tours, Travel Sri Lanka, Tour Packages, Adventure Tours, Wildlife Safari, Beach Holidays, Beruwala Tours"
                  url="https://picklanka.com/au/home"
                />
                <Home />
              </>
            }
          />
          <Route
            path="/au/about-us"
            element={
              <>
                <SEO
                  title="About Us - Pick Lanka Tours"
                  description="Learn about Pick Lanka Tours, your trusted Sri Lankan travel partner offering personalized and memorable tour experiences across the island."
                  keywords="Pick Lanka Tours, About Pick Lanka, Sri Lanka Travel Company, Beruwala Tours, Sri Lanka Tour Operator"
                  url="https://picklanka.com/au/about-us"
                />
                <About />
              </>
            }
          />
          <Route
            path="/au/srilanka"
            element={
              <>
                <SEO
                  title="Explore Sri Lanka - Pick Lanka Tours"
                  description="Discover the wonders of Sri Lanka with Pick Lanka Tours — from golden beaches to wildlife safaris and scenic hill country."
                  keywords="Explore Sri Lanka, Pick Lanka Tours, Sri Lanka Travel, Nature Tours, Wildlife Safari, Beach Holidays"
                  url="https://picklanka.com/au/srilanka"
                />
                <SriLanka />
              </>
            }
          />
          <Route
            path="/au/tour"
            element={
              <>
                <SEO
                  title="Tour Packages - Pick Lanka Tours"
                  description="Choose from our exclusive Pick Lanka Tours packages featuring wildlife adventures, beach getaways, and nature experiences."
                  keywords="Sri Lanka Tour Packages, Pick Lanka Tours, Adventure Tours, Wildlife Tours, Holiday Packages"
                  url="https://picklanka.com/au/tour"
                />
                <TourPackages />
              </>
            }
          />
          <Route
            path="/au/gallery"
            element={
              <>
                <SEO
                  title="Gallery - Pick Lanka Tours"
                  description="Browse through moments captured during Pick Lanka Tours’ amazing journeys across Sri Lanka."
                  keywords="Sri Lanka Travel Photos, Pick Lanka Tours Gallery, Sri Lanka Adventures, Travel Memories"
                  url="https://picklanka.com/au/gallery"
                />
                <Gallery />
              </>
            }
          />
          <Route
            path="/au/events"
            element={
              <>
                <SEO
                  title="Events - Pick Lanka Tours"
                  description="Celebrate Sri Lanka’s colorful festivals and special events with Pick Lanka Tours — where culture meets adventure."
                  keywords="Sri Lanka Events, Pick Lanka Tours, Cultural Festivals, Local Experiences"
                  url="https://picklanka.com/au/events"
                />
                <Events />
              </>
            }
          />
          <Route
            path="/au/things"
            element={
              <>
                <SEO
                  title="Things To Do - Pick Lanka Tours"
                  description="Find exciting things to do with Pick Lanka Tours — from safaris and diving to hot air ballooning and tea tasting."
                  keywords="Things To Do Sri Lanka, Pick Lanka Tours, Adventure Activities, Safari Tours, Sri Lanka Experiences"
                  url="https://picklanka.com/au/things"
                />
                <ThingsToDo />
              </>
            }
          />
          <Route
            path="/au/bookings"
            element={
              <>
                <SEO
                  title="Bookings - Pick Lanka Tours"
                  description="Book your dream Sri Lankan tour with Pick Lanka. Easy reservations and custom travel experiences await you!"
                  keywords="Book Sri Lanka Tours, Pick Lanka Bookings, Travel Reservations, Holiday Packages"
                  url="https://picklanka.com/au/bookings"
                />
                <Bookings />
              </>
            }
          />
          <Route
            path="/au/contact-us"
            element={
              <>
                <SEO
                  title="Contact Us - Pick Lanka Tours"
                  description="Get in touch with Pick Lanka Tours for travel inquiries and bookings. Call us or message via WhatsApp for quick assistance."
                  keywords="Contact Pick Lanka, Sri Lanka Tour Contact, Beruwala Tours, Travel Inquiries"
                  url="https://picklanka.com/au/contact-us"
                />
                <ContactUs />
              </>
            }
          />
          <Route
            path="/au/ayurveda"
            element={
              <>
                <SEO
                  title="Ayurveda Experiences - Pick Lanka Tours"
                  description="Rejuvenate your body and mind with traditional Ayurveda treatments arranged by Pick Lanka Tours in Sri Lanka."
                  keywords="Ayurveda Sri Lanka, Pick Lanka Wellness Tours, Traditional Healing, Spa Packages"
                  url="https://picklanka.com/au/ayurveda"
                />
                <AyurvedaPage />
              </>
            }
          />
          <Route
            path="/au/diving"
            element={
              <>
                <SEO
                  title="Diving in Sri Lanka - Pick Lanka Tours"
                  description="Explore the vibrant marine life of Sri Lanka with diving adventures guided by Pick Lanka Tours."
                  keywords="Diving Sri Lanka, Pick Lanka Diving, Underwater Adventures, Coral Reefs"
                  url="https://picklanka.com/au/diving"
                />
                <DivingPage />
              </>
            }
          />
          <Route
            path="/au/elephant-ride"
            element={
              <>
                <SEO
                  title="Elephant Experiences - Pick Lanka Tours"
                  description="Get close to Sri Lanka’s gentle giants with Pick Lanka’s ethical elephant experiences and safaris."
                  keywords="Elephant Safari Sri Lanka, Pick Lanka Tours, Wildlife Experiences"
                  url="https://picklanka.com/au/elephant-ride"
                />
                <ElephantRidePage />
              </>
            }
          />
          <Route
            path="/au/fishing"
            element={
              <>
                <SEO
                  title="Fishing Trips - Pick Lanka Tours"
                  description="Enjoy exciting fishing excursions along Sri Lanka’s coastal waters with Pick Lanka Tours."
                  keywords="Fishing Sri Lanka, Pick Lanka Tours, Deep Sea Fishing, Adventure Tours"
                  url="https://picklanka.com/au/fishing"
                />
                <FishingPage />
              </>
            }
          />
          <Route
            path="/au/ballooning"
            element={
              <>
                <SEO
                  title="Hot Air Ballooning - Pick Lanka Tours"
                  description="Soar high over Sri Lanka’s breathtaking scenery with Pick Lanka’s hot air balloon rides."
                  keywords="Hot Air Ballooning Sri Lanka, Pick Lanka Adventure, Scenic Flights"
                  url="https://picklanka.com/au/ballooning"
                />
                <BallooningPage />
              </>
            }
          />
          <Route
            path="/au/jeep-safari"
            element={
              <>
                <SEO
                  title="Jeep Safari - Pick Lanka Tours"
                  description="Join Pick Lanka for thrilling jeep safaris through Sri Lanka’s wildlife-rich national parks."
                  keywords="Jeep Safari Sri Lanka, Pick Lanka Wildlife, National Park Safari"
                  url="https://picklanka.com/au/jeep-safari"
                />
                <JeepSafariPage />
              </>
            }
          />
          <Route
            path="/au/white-water-rafting"
            element={
              <>
                <SEO
                  title="White Water Rafting - Pick Lanka Tours"
                  description="Experience adrenaline-pumping white water rafting in Kitulgala with Pick Lanka Tours."
                  keywords="White Water Rafting Sri Lanka, Pick Lanka Adventures, Kitulgala Rafting"
                  url="https://picklanka.com/au/white-water-rafting"
                />
                <WhiteWaterRaftingPage />
              </>
            }
          />
          <Route
            path="/au/river-safari"
            element={
              <>
                <SEO
                  title="River Safari - Pick Lanka Tours"
                  description="Relax and enjoy Sri Lanka’s beautiful river ecosystems on a scenic safari with Pick Lanka Tours."
                  keywords="River Safari Sri Lanka, Pick Lanka Nature Tours, Boat Rides"
                  url="https://picklanka.com/au/river-safari"
                />
                <RiverSafariPage />
              </>
            }
          />
          <Route
            path="/au/snorkeling"
            element={
              <>
                <SEO
                  title="Snorkeling Adventures - Pick Lanka Tours"
                  description="Discover Sri Lanka’s colorful coral reefs and tropical fish on a snorkeling trip with Pick Lanka Tours."
                  keywords="Snorkeling Sri Lanka, Pick Lanka Marine Tours, Beach Activities"
                  url="https://picklanka.com/au/snorkeling"
                />
                <SnorkelingPage />
              </>
            }
          />
          <Route
            path="/au/tea-tasting"
            element={
              <>
                <SEO
                  title="Tea Tasting - Pick Lanka Tours"
                  description="Savor the rich aroma of Ceylon tea on an exclusive tea tasting journey with Pick Lanka Tours."
                  keywords="Tea Tasting Sri Lanka, Pick Lanka Tours, Ceylon Tea, Hill Country Tours"
                  url="https://picklanka.com/au/tea-tasting"
                />
                <TeaTastingPage />
              </>
            }
          />
          <Route
            path="/au/temple-visit"
            element={
              <>
                <SEO
                  title="Temple Visits - Pick Lanka Tours"
                  description="Discover Sri Lanka’s sacred temples and ancient stories through Pick Lanka’s guided tours."
                  keywords="Temple Visit Sri Lanka, Pick Lanka Tours, Cultural Experiences"
                  url="https://picklanka.com/au/temple-visit"
                />
                <TempleVisitPage />
              </>
            }
          />
          <Route
            path="/au/wildlife-safari"
            element={
              <>
                <SEO
                  title="Wildlife Safari - Pick Lanka Tours"
                  description="Embark on thrilling wildlife safaris across Sri Lanka’s national parks with Pick Lanka Tours."
                  keywords="Wildlife Safari Sri Lanka, Pick Lanka Tours, National Park Tours, Elephant Safari"
                  url="https://picklanka.com/au/wildlife-safari"
                />
                <WildlifeSafariPage />
              </>
            }
          />
          {/* JP Routes (Japanese) */}
          <Route
            path="/jp"
            element={
              <>
                <SEO
                  title="Pick Lanka Tours - Discover Sri Lanka"
                  description="Join Pick Lanka Tours to explore Sri Lanka's stunning landscapes, wildlife safaris, and breathtaking adventures. Let's make your journey unforgettable!"
                  keywords="Pick Lanka Tours, Sri Lanka Tours, Travel Sri Lanka, Tour Packages, Adventure Tours, Wildlife Safari, Beach Holidays, Beruwala Tours"
                  url="https://picklanka.com/jp"
                />
                <Home />
              </>
            }
          />
          <Route
            path="/jp/home"
            element={
              <>
                <SEO
                  title="Pick Lanka Tours - Discover Sri Lanka"
                  description="Join Pick Lanka Tours to explore Sri Lanka's stunning landscapes, wildlife safaris, and breathtaking adventures. Let's make your journey unforgettable!"
                  keywords="Pick Lanka Tours, Sri Lanka Tours, Travel Sri Lanka, Tour Packages, Adventure Tours, Wildlife Safari, Beach Holidays, Beruwala Tours"
                  url="https://picklanka.com/jp/home"
                />
                <Home />
              </>
            }
          />
          <Route
            path="/jp/about-us"
            element={
              <>
                <SEO
                  title="About Us - Pick Lanka Tours"
                  description="Learn about Pick Lanka Tours, your trusted Sri Lankan travel partner offering personalized and memorable tour experiences across the island."
                  keywords="Pick Lanka Tours, About Pick Lanka, Sri Lanka Travel Company, Beruwala Tours, Sri Lanka Tour Operator"
                  url="https://picklanka.com/jp/about-us"
                />
                <About />
              </>
            }
          />
          <Route
            path="/jp/srilanka"
            element={
              <>
                <SEO
                  title="Explore Sri Lanka - Pick Lanka Tours"
                  description="Discover the wonders of Sri Lanka with Pick Lanka Tours — from golden beaches to wildlife safaris and scenic hill country."
                  keywords="Explore Sri Lanka, Pick Lanka Tours, Sri Lanka Travel, Nature Tours, Wildlife Safari, Beach Holidays"
                  url="https://picklanka.com/jp/srilanka"
                />
                <SriLanka />
              </>
            }
          />
          <Route
            path="/jp/tour"
            element={
              <>
                <SEO
                  title="Tour Packages - Pick Lanka Tours"
                  description="Choose from our exclusive Pick Lanka Tours packages featuring wildlife adventures, beach getaways, and nature experiences."
                  keywords="Sri Lanka Tour Packages, Pick Lanka Tours, Adventure Tours, Wildlife Tours, Holiday Packages"
                  url="https://picklanka.com/jp/tour"
                />
                <TourPackages />
              </>
            }
          />
          <Route
            path="/jp/gallery"
            element={
              <>
                <SEO
                  title="Gallery - Pick Lanka Tours"
                  description="Browse through moments captured during Pick Lanka Tours' amazing journeys across Sri Lanka."
                  keywords="Sri Lanka Travel Photos, Pick Lanka Tours Gallery, Sri Lanka Adventures, Travel Memories"
                  url="https://picklanka.com/jp/gallery"
                />
                <Gallery />
              </>
            }
          />
          <Route
            path="/jp/events"
            element={
              <>
                <SEO
                  title="Events - Pick Lanka Tours"
                  description="Celebrate Sri Lanka's colorful festivals and special events with Pick Lanka Tours — where culture meets adventure."
                  keywords="Sri Lanka Events, Pick Lanka Tours, Cultural Festivals, Local Experiences"
                  url="https://picklanka.com/jp/events"
                />
                <Events />
              </>
            }
          />
          <Route
            path="/jp/things"
            element={
              <>
                <SEO
                  title="Things To Do - Pick Lanka Tours"
                  description="Find exciting things to do with Pick Lanka Tours — from safaris and diving to hot air ballooning and tea tasting."
                  keywords="Things To Do Sri Lanka, Pick Lanka Tours, Adventure Activities, Safari Tours, Sri Lanka Experiences"
                  url="https://picklanka.com/jp/things"
                />
                <ThingsToDo />
              </>
            }
          />
          <Route
            path="/jp/bookings"
            element={
              <>
                <SEO
                  title="Bookings - Pick Lanka Tours"
                  description="Book your dream Sri Lankan tour with Pick Lanka. Easy reservations and custom travel experiences await you!"
                  keywords="Book Sri Lanka Tours, Pick Lanka Bookings, Travel Reservations, Holiday Packages"
                  url="https://picklanka.com/jp/bookings"
                />
                <Bookings />
              </>
            }
          />
          <Route
            path="/jp/contact-us"
            element={
              <>
                <SEO
                  title="Contact Us - Pick Lanka Tours"
                  description="Get in touch with Pick Lanka Tours for travel inquiries and bookings. Call us or message via WhatsApp for quick assistance."
                  keywords="Contact Pick Lanka, Sri Lanka Tour Contact, Beruwala Tours, Travel Inquiries"
                  url="https://picklanka.com/jp/contact-us"
                />
                <ContactUs />
              </>
            }
          />
          <Route
            path="/jp/ayurveda"
            element={
              <>
                <SEO
                  title="Ayurveda Experiences - Pick Lanka Tours"
                  description="Rejuvenate your body and mind with traditional Ayurveda treatments arranged by Pick Lanka Tours in Sri Lanka."
                  keywords="Ayurveda Sri Lanka, Pick Lanka Wellness Tours, Traditional Healing, Spa Packages"
                  url="https://picklanka.com/jp/ayurveda"
                />
                <AyurvedaPage />
              </>
            }
          />
          <Route
            path="/jp/diving"
            element={
              <>
                <SEO
                  title="Diving in Sri Lanka - Pick Lanka Tours"
                  description="Explore the vibrant marine life of Sri Lanka with diving adventures guided by Pick Lanka Tours."
                  keywords="Diving Sri Lanka, Pick Lanka Diving, Underwater Adventures, Coral Reefs"
                  url="https://picklanka.com/jp/diving"
                />
                <DivingPage />
              </>
            }
          />
          <Route
            path="/jp/elephant-ride"
            element={
              <>
                <SEO
                  title="Elephant Experiences - Pick Lanka Tours"
                  description="Get close to Sri Lanka's gentle giants with Pick Lanka's ethical elephant experiences and safaris."
                  keywords="Elephant Safari Sri Lanka, Pick Lanka Tours, Wildlife Experiences"
                  url="https://picklanka.com/jp/elephant-ride"
                />
                <ElephantRidePage />
              </>
            }
          />
          <Route
            path="/jp/fishing"
            element={
              <>
                <SEO
                  title="Fishing Trips - Pick Lanka Tours"
                  description="Enjoy exciting fishing excursions along Sri Lanka's coastal waters with Pick Lanka Tours."
                  keywords="Fishing Sri Lanka, Pick Lanka Tours, Deep Sea Fishing, Adventure Tours"
                  url="https://picklanka.com/jp/fishing"
                />
                <FishingPage />
              </>
            }
          />
          <Route
            path="/jp/ballooning"
            element={
              <>
                <SEO
                  title="Hot Air Ballooning - Pick Lanka Tours"
                  description="Soar high over Sri Lanka's breathtaking scenery with Pick Lanka's hot air balloon rides."
                  keywords="Hot Air Ballooning Sri Lanka, Pick Lanka Adventure, Scenic Flights"
                  url="https://picklanka.com/jp/ballooning"
                />
                <BallooningPage />
              </>
            }
          />
          <Route
            path="/jp/jeep-safari"
            element={
              <>
                <SEO
                  title="Jeep Safari - Pick Lanka Tours"
                  description="Join Pick Lanka for thrilling jeep safaris through Sri Lanka's wildlife-rich national parks."
                  keywords="Jeep Safari Sri Lanka, Pick Lanka Wildlife, National Park Safari"
                  url="https://picklanka.com/jp/jeep-safari"
                />
                <JeepSafariPage />
              </>
            }
          />
          <Route
            path="/jp/white-water-rafting"
            element={
              <>
                <SEO
                  title="White Water Rafting - Pick Lanka Tours"
                  description="Experience adrenaline-pumping white water rafting in Kitulgala with Pick Lanka Tours."
                  keywords="White Water Rafting Sri Lanka, Pick Lanka Adventures, Kitulgala Rafting"
                  url="https://picklanka.com/jp/white-water-rafting"
                />
                <WhiteWaterRaftingPage />
              </>
            }
          />
          <Route
            path="/jp/river-safari"
            element={
              <>
                <SEO
                  title="River Safari - Pick Lanka Tours"
                  description="Relax and enjoy Sri Lanka's beautiful river ecosystems on a scenic safari with Pick Lanka Tours."
                  keywords="River Safari Sri Lanka, Pick Lanka Nature Tours, Boat Rides"
                  url="https://picklanka.com/jp/river-safari"
                />
                <RiverSafariPage />
              </>
            }
          />
          <Route
            path="/jp/snorkeling"
            element={
              <>
                <SEO
                  title="Snorkeling Adventures - Pick Lanka Tours"
                  description="Discover Sri Lanka's colorful coral reefs and tropical fish on a snorkeling trip with Pick Lanka Tours."
                  keywords="Snorkeling Sri Lanka, Pick Lanka Marine Tours, Beach Activities"
                  url="https://picklanka.com/jp/snorkeling"
                />
                <SnorkelingPage />
              </>
            }
          />
          <Route
            path="/jp/tea-tasting"
            element={
              <>
                <SEO
                  title="Tea Tasting - Pick Lanka Tours"
                  description="Savor the rich aroma of Ceylon tea on an exclusive tea tasting journey with Pick Lanka Tours."
                  keywords="Tea Tasting Sri Lanka, Pick Lanka Tours, Ceylon Tea, Hill Country Tours"
                  url="https://picklanka.com/jp/tea-tasting"
                />
                <TeaTastingPage />
              </>
            }
          />
          <Route
            path="/jp/temple-visit"
            element={
              <>
                <SEO
                  title="Temple Visits - Pick Lanka Tours"
                  description="Discover Sri Lanka's sacred temples and ancient stories through Pick Lanka's guided tours."
                  keywords="Temple Visit Sri Lanka, Pick Lanka Tours, Cultural Experiences"
                  url="https://picklanka.com/jp/temple-visit"
                />
                <TempleVisitPage />
              </>
            }
          />
          <Route
            path="/jp/wildlife-safari"
            element={
              <>
                <SEO
                  title="Wildlife Safari - Pick Lanka Tours"
                  description="Embark on thrilling wildlife safaris across Sri Lanka's national parks with Pick Lanka Tours."
                  keywords="Wildlife Safari Sri Lanka, Pick Lanka Tours, National Park Tours, Elephant Safari"
                  url="https://picklanka.com/jp/wildlife-safari"
                />
                <WildlifeSafariPage />
              </>
            }
          />        </Routes>
      </main>
      <WhatsApp />
      <Facebook />
      <Instagram />
      <Footer />
    </Router>
  );
};

export default App;